import { render, staticRenderFns } from "./TransactionsSummary.vue?vue&type=template&id=0b7b11bd&scoped=true"
import script from "./TransactionsSummary.vue?vue&type=script&lang=js"
export * from "./TransactionsSummary.vue?vue&type=script&lang=js"
import style0 from "./TransactionsSummary.vue?vue&type=style&index=0&id=0b7b11bd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b7b11bd",
  null
  
)

export default component.exports